import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getMaxPrice } from '../redux/shared/selectors';
import { dollarsToPoints } from '../utils/points';
import { Props } from './PointsInput';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = (state, ownProps) => ({
  maxValue: ownProps.maxValue || dollarsToPoints(getMaxPrice(state)),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
